import _keyBy from 'lodash/keyBy';

import { CronFrequencyEnum, DayOfWeekEnum, MonthOfYearEnum, WeekOfMonthEnum } from '@/types/schema';

export const EmailDigestFrequency = [
  { value: CronFrequencyEnum.Daily, label: 'Daily' },
  { value: CronFrequencyEnum.Weekly, label: 'Weekly' },
  { value: CronFrequencyEnum.Fortnightly, label: 'Fortnightly' },
  { value: CronFrequencyEnum.Monthly, label: 'Monthly' },
  { value: CronFrequencyEnum.Quarterly, label: 'Quarterly' },
  { value: CronFrequencyEnum.Yearly, label: 'Yearly' },
  { value: CronFrequencyEnum.Custom, label: 'Custom' },
];

export const DaysOfWeek = [
  {
    id: DayOfWeekEnum.Monday,
    labelKey: 'Weekdays.Monday',
    shortLabelKey: 'Weekdays.Short_Monday',
  },
  {
    id: DayOfWeekEnum.Tuesday,
    labelKey: 'Weekdays.Tuesday',
    shortLabelKey: 'Weekdays.Short_Tuesday',
  },
  {
    id: DayOfWeekEnum.Wednesday,
    labelKey: 'Weekdays.Wednesday',
    shortLabelKey: 'Weekdays.Short_Wednesday',
  },
  {
    id: DayOfWeekEnum.Thursday,
    labelKey: 'Weekdays.Thursday',
    shortLabelKey: 'Weekdays.Short_Thursday',
  },
  {
    id: DayOfWeekEnum.Friday,
    labelKey: 'Weekdays.Friday',
    shortLabelKey: 'Weekdays.Short_Friday',
  },
  {
    id: DayOfWeekEnum.Saturday,
    labelKey: 'Weekdays.Saturday',
    shortLabelKey: 'Weekdays.Short_Saturday',
  },
  {
    id: DayOfWeekEnum.Sunday,
    labelKey: 'Weekdays.Sunday',
    shortLabelKey: 'Weekdays.Short_Sunday',
  },
];

export const WeekOfMonth = [
  {
    id: WeekOfMonthEnum.First,
    labelKey: 'WeekOfMonth.First',
  },
  {
    id: WeekOfMonthEnum.Second,
    labelKey: 'WeekOfMonth.Second',
  },
  {
    id: WeekOfMonthEnum.Third,
    labelKey: 'WeekOfMonth.Third',
  },
  {
    id: WeekOfMonthEnum.Fourth,
    labelKey: 'WeekOfMonth.Fourth',
  },
  {
    id: WeekOfMonthEnum.Last,
    labelKey: 'WeekOfMonth.Last',
  },
];

export const OrderedMonthsOfYear = [
  MonthOfYearEnum.January,
  MonthOfYearEnum.February,
  MonthOfYearEnum.March,
  MonthOfYearEnum.April,
  MonthOfYearEnum.May,
  MonthOfYearEnum.June,
  MonthOfYearEnum.July,
  MonthOfYearEnum.August,
  MonthOfYearEnum.September,
  MonthOfYearEnum.October,
  MonthOfYearEnum.November,
  MonthOfYearEnum.December,
];

export const daysOfWeekById = _keyBy(DaysOfWeek, 'id');
export const weekOfMonthById = _keyBy(WeekOfMonth, 'id');

export const DEFAULT_DAY_OF_WEEK = DayOfWeekEnum.Monday;
export const DEFAULT_WEEK_OF_MONTH = WeekOfMonthEnum.First;
